/* The delivery estimate's second pass.

   Liquid renders a first answer so the block is never blank, then this corrects
   it in the shopper's own browser against the configured timezone and keeps the
   countdown ticking. That matters because Shopify caches storefront HTML: a
   purely server rendered cutoff can be hours stale and would count down to a
   time that has already gone.

   It lives in a file rather than inline in the snippet because the estimate now
   renders on product cards too, and a collection page shows a hundred of them.
   A hundred copies of this in the HTML is a hundred copies of the bytes; one
   file is one request, cached, however many estimates are on the page.

   It reads every [data-delivery-estimate] on the page, so it does not care how
   many there are or where they came from. */
;(function () {
  if (window.__acDeliveryEstimate) return
  window.__acDeliveryEstimate = true

  function zoneNow(zone) {
    var parts = {}
    new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
      .formatToParts(new Date())
      .forEach(function (part) {
        parts[part.type] = part.value
      })
    return {
      year: +parts.year,
      month: +parts.month,
      day: +parts.day,
      /* Some locales report midnight as hour 24. */
      hour: +parts.hour % 24,
      minute: +parts.minute,
    }
  }

  /* Calendar maths runs on a UTC date so that adding a day never lands on a
     DST seam. Only the date matters here, never the time of day. */
  function isWorkingDay(date) {
    var weekday = date.getUTCDay()
    return weekday !== 0 && weekday !== 6
  }

  function update(el) {
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10)
    var transit = parseInt(el.dataset.transitDays, 10)
    var now
    try {
      now = zoneNow(el.dataset.timezone)
    } catch (e) {
      /* An unknown timezone leaves the server's answer in place. */
      return
    }
    if (isNaN(cutoffHour) || isNaN(transit) || isNaN(now.year)) return

    var day = new Date(Date.UTC(now.year, now.month - 1, now.day))
    var minutesLeft = cutoffHour * 60 - (now.hour * 60 + now.minute)

    if (!isWorkingDay(day) || minutesLeft <= 0) {
      do {
        day.setUTCDate(day.getUTCDate() + 1)
      } while (!isWorkingDay(day))
      minutesLeft = null
    }

    var arrival = new Date(day.getTime())
    var remaining = transit
    var guard = 0
    while (remaining > 0 && guard < 60) {
      arrival.setUTCDate(arrival.getUTCDate() + 1)
      if (isWorkingDay(arrival)) remaining--
      guard++
    }

    var dateEl = el.querySelector('[data-delivery-date]')
    if (dateEl) {
      dateEl.textContent = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC',
        weekday: 'short',
        month: 'short',
        day: '2-digit',
      }).format(arrival)
    }

    var cutoffEl = el.querySelector('[data-delivery-cutoff]')
    if (!cutoffEl) return
    if (minutesLeft === null) {
      cutoffEl.hidden = true
      return
    }
    var hours = Math.floor(minutesLeft / 60)
    var minutes = minutesLeft % 60
    var span =
      (hours > 0 ? hours + ' ' + el.dataset.hoursLabel + ' ' : '') + minutes + ' ' + el.dataset.minutesLabel
    /* The sentence comes from the locale file on the element, so no English
       is spelled out in here. */
    cutoffEl.textContent = cutoffEl.dataset.template.replace('__TIME__', span)
    cutoffEl.hidden = false
  }

  function tick() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(update)
  }

  tick()
  setInterval(tick, 30000)
})()
